// src/stone/icons/SignalFormStar.tsx
import { jsx } from "react/jsx-runtime";
var SignalFormStar = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "currentcolor",
        d: "m20 3.333 5.15 10.433 11.517 1.684-8.334 8.116L30.3 35.033 20 29.616 9.7 35.033l1.967-11.467-8.334-8.116 11.517-1.684z"
      }
    )
  }
);
var SignalFormStar_default = SignalFormStar;

export {
  SignalFormStar_default
};
